__turbopack_context__.v({
  "dividerX": "get_started_overlay-module-scss-module__OVyVPq__dividerX",
  "dividerY": "get_started_overlay-module-scss-module__OVyVPq__dividerY",
  "getStartViewDivider": "get_started_overlay-module-scss-module__OVyVPq__getStartViewDivider",
  "getstartViewDialogContent": "get_started_overlay-module-scss-module__OVyVPq__getstartViewDialogContent",
  "getstartViewDialogTitle": "get_started_overlay-module-scss-module__OVyVPq__getstartViewDialogTitle",
  "videoContainer": "get_started_overlay-module-scss-module__OVyVPq__videoContainer",
  "videoViewContent": "get_started_overlay-module-scss-module__OVyVPq__videoViewContent",
});
